module.exports = __webpack_public_path__ + "static/media/live-receptionist.587a8bdd.png";